export const STORAGE_URL="https://storage.tetedo.com";